import { gql } from "@apollo/client";

export const GET_PREQUALIFICATION_INFO = gql`
  query GetPrequalificationInfo {
    getPrequalificationInfo {
      id
      status
      firstName
      lastName
      email
      phone
      street
      city
      state
      zip
      dateOfBirth
      petId
      limit
      balance
      checkedAt
      expiresAt
      scratchReference
      errorReason
      selectedPlanId
      selectedBilling
      fulfilledByTransactionId
      fulfilledAt
    }
  }
`;
